// src/components/NavbarComponents/navData.ts
import { NavLink } from '@/types/nav';

export const navLinks: NavLink[] = [
  { 
    name: 'Domov', 
    path: '/', 
    hasDropdown: false 
  },
  { 
    name: 'Keramika', 
    path: '/keramika', 
    hasDropdown: true,
    overview: { name: 'Pregled keramike', path: '/keramika' }, // Custom overview name
    dropdownItems: [
      { name: 'Videz lesa', path: '/keramika/videz-lesa', title: 'Keramične ploščice videz lesa' },
      { name: 'Videz marmorja', path: '/keramika/videz-marmorja', title: 'Keramične ploščice videz marmorja' },
      { name: 'Videz betona, kamna', path: '/keramika/videz-betona-kamna', title: 'Keramične ploščice videz betona, kamna' },
      { name: 'Dekor', path: '/keramika/dekor', title: 'Keramične ploščice Dekor' },
      { name: 'Velikoformatna keramika', path: '/keramika/velikoformatna-keramika', title: 'Velikoformatna keramika' },
    ]
  },
  { 
    name: 'Kamen', 
    path: '/kamen', 
    hasDropdown: true,
    overview: { name: 'Pregled kamna', path: '/kamen' }, // Custom overview name
    dropdownItems: [
      { name: 'Tehnični kamen', path: '/kamen/tehnicni-kamen', title: 'Tehnični kamen' },
      { name: 'Granit', path: '/kamen/granit', title: 'Granit' },
      { name: 'Okenske police', path: '/kamen/okenske-police', title: 'Okenske police' },
      { name: 'Stopnice', path: '/kamen/stopnice', title: 'Stopnice' },
      { name: 'Tlaki', path: '/kamen/tlaki', title: 'Tlaki' },
    ]
  },
  { 
    name: 'Pulti', 
    path: '/pulti', 
    hasDropdown: true,
    overview: { name: 'Pregled pultov', path: '/pulti' }, // Custom overview name
    dropdownItems: [
      { name: 'ABK stone pulti', path: '/pulti/abk-stone-pulti', title: 'ABK stone pulti' },
      { name: 'Granit pulti', path: '/pulti/granit-pulti', title: 'Granit pulti' },
      { name: 'Quartz pulti', path: '/pulti/quartz-pulti', title: 'Quartz pulti' },
    ]
  },
  { 
    name: 'Storitve', 
    path: '/storitve', 
    hasDropdown: false 
  },
  { 
    name: 'Nasveti/Blog', 
    path: '/nasveti-blog', 
    hasDropdown: false 
  },
  { 
    name: 'Kontakt', 
    path: '/kontakt', 
    hasDropdown: false 
  },
];